// Golem fork (FT-1469): WHAT SHAPE a seat wears — the round cog, or a portrait
// TAROT CARD the role art sits on.
//
// Built as the coin dress's twin (golem/coinArt): the choice is published as a
// CSS custom property on the document root, so switching frame is a repaint —
// the seat reads var(--seat-frame) and keys its portrait box off the
// `seat-frame-tarot` class the coin (Token.vue) binds from `frameChoice`. A
// LOCAL choice, this browser only, remembered per account through the
// `seatFrame` pref (golem/prefs owns the remembered value and calls applyFrame
// on every prefs landing, exactly as it does applyCoin).
//
// SLICE 1: the tarot frame dresses the seat's PRIMARY ALIVE face only. The
// dead face, shroud, ring geometry, name plate, reminder fan and townsquare
// ring are still the coin's — see the ticket's deferred-states list.
import Vue from "vue";

import tarotBlank from "../assets/frames/tarot-blank.png";

// The frames a seat can wear. `coin` is the app's standing look and the
// default; `tarot` is the portrait card. Kept as a list so a picker can offer
// them the way the coin lab offers COINS.
export const FRAMES = [
  { id: "coin", label: "Cog" },
  { id: "tarot", label: "Tarot card" }
];

const KEY = "golem.seatFrame";
let stored = null;
try {
  stored = localStorage.getItem(KEY);
} catch (e) {
  stored = null;
}
if (!FRAMES.some(f => f.id === stored)) stored = FRAMES[0].id;

export const frameChoice = Vue.observable({ id: stored });

/** Paint the choice onto the root so every seat follows it. The tarot image
 *  rides a var so the two component scopes (Token.vue's face, Player.vue's
 *  box) read one source; the `seat-frame-tarot` class the coin binds is what
 *  actually turns the card on. */
export function applyFrame(id) {
  const pick = FRAMES.some(f => f.id === id) ? id : FRAMES[0].id;
  frameChoice.id = pick;
  document.documentElement.style.setProperty(
    "--seat-frame",
    `url(${tarotBlank})`
  );
  try {
    localStorage.setItem(KEY, pick);
  } catch (e) {
    // a browser with storage off still gets the swap for this session
  }
}

applyFrame(stored);
